<template>
  <div>
    <el-main>
      <div class="area">
        <div class="box">
          <p class="return" @click="$router.go(-1)">返回</p>
          <span class="line">|</span>
          <p class="contract">修改密码</p>
        </div>
        <div class="m_nav">
          <span class="mobile">登录账号：</span><span>{{ mobile }}</span>
        </div>
        <div class="stepdiv">
          <div class="steps initiate">
            <el-steps
              :active="active"
              finish-status="success"
              align-center
              space="200px"
            >
              <el-step title="填写验证信息"></el-step>
              <el-step title="设置新密码"></el-step>
            </el-steps>
          </div>
          <div class="formclass" v-show="active == 0">
            <el-form
              ref="edit"
              label-width="100px"
              :rules="rules"
              :model="baseInfo"
              label-position="right"
            >
              <el-form-item label="图形验证码" prop="picvert">
                <el-input v-model="baseInfo.picvert"></el-input>
                <div class="mobilecert">
                  <img class="imgcert" :src="validcodeurl" />
                  <div
                    :class="
                      switchstatus == false
                        ? 'switchbtn'
                        : 'switchbtn switchbtn_click'
                    "
                    @click="onswitch"
                  ></div>
                </div>
              </el-form-item>
              <el-form-item label="手机验证码" prop="validcode">
                <el-input v-model="baseInfo.validcode"></el-input>
                <button
                  class="btn subbtn mobilecert"
                  v-if="!timeshow"
                  type="button"
                  @click="sendSms"
                >
                  获取验证码
                </button>
                <button type="button" class="nosmsbtn" v-if="timeshow" disabled>
                  {{ count }} 重新发送
                </button>
              </el-form-item>
            </el-form>
            <button class="btn subbtn" @click="next">下一步</button>
          </div>
          <div class="formclass" v-show="active == 1">
            <el-form
              ref="finsh"
              label-width="100px"
              :rules="passrules"
              :model="passinfo"
              label-position="right"
            >
              <el-form-item label="新密码" prop="password">
                <el-input
                  v-model="passinfo.password"
                  type="password"
                ></el-input>
                <!-- <i class="el-icon-circle-check"></i> -->
              </el-form-item>

              <el-form-item label="确认新密码" prop="repassword">
                <el-input
                  v-model="passinfo.repassword"
                  type="password"
                ></el-input>
              </el-form-item>
            </el-form>
            <button style="margin-right: 10px" class="btn subbtn" @click="pre">
              上一步
            </button>
            <button class="btn subbtn" @click="finish">完成</button>
          </div>
        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
export default {
  name: "SsgChangePasswd",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.passinfo.repassword !== "") {
          this.$refs.finsh.validateField("repassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.passinfo.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      active: 0,
      mobile: "",
      baseInfo: {},
      rules: {
        picvert: [
          {
            required: true,
            message: "请输入图形验证码",
            trigger: "blur",
          },
        ],
        validcode: [
          {
            required: true,
            message: "请输入手机验证码",
            trigger: "blur",
          },
        ],
      },
      passinfo: {
        password: "",
        repassword: "",
      },
      passrules: {
        password: [
          { required: true, validator: validatePass, trigger: "blur" },
          {
            required: true,
            min: 8,
            max: 32,
            message: "密码长度必须为 8 到 32 个字符",
            trigger: "blur",
          },
          {
            required: true,
            pattern:
            /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,32}$/,
            message:
              " 必须包含三种及以上类型：大写字母、小写字母、数字、特殊符号。特殊字符包括!@ # $ % ^ & * () _ + - =",
            trigger: "blur",
          },

        ],
        repassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
      switchstatus: false, //切换验证码,
      validcodeurl: this.$axios.defaults.baseURL + "/send/imageCode_czmm",
      count: "", //倒计时
      timer: null, //倒计时状态
      timeshow: false,
    };
  },
  created() {
    this.mobile = this.$route.query.mobile;
  },
  methods: {
    back() {
      this.$router.push({ path: "/main" });
    },
    next() {
      this.$refs.edit.validate((valid) => {
        if (valid) {
          this.$axios
            .post(
              "/person/czmmValidCode?imageValidCode=" +
                this.baseInfo.picvert +
                "&mobileValidCode=" +
                this.baseInfo.validcode
            )
            .then((res) => {
              if (res.data.status == 1) {
                this.active = 1;
              } else {
                this.$message.error(res.data.message);
              }
            });
        }
      });
    },
    finish() {
      this.$refs.finsh.validate((valid) => {
        if (valid) {
          this.$axios
            .post(
              "/person/updatePassword?newPassword=" +
                this.passinfo.password +
                "&validPassword=" +
                this.passinfo.repassword
            )
            .then((res) => {
              if (res.data.status == "0") {
                this.$message.error(res.data.message);
              } else {
                this.$message.success(res.data.message);
                this.$router.push({ path: "/login" });
              }
            });
        }
      });
    },
    pre() {
      this.active = 0;
    },
    sendSms() {
      this.$axios.get("/send/mobelCode_czmm").then((res) => {
        if (res.data.status === "0") {
          this.$message.error(res.data.message);
        } else {
          this.getCode();
        }
      });
    },
    realSendSms() {
      let params = { mobile: this.mobile };
      axios.post("/pages/smscode", params).then((res) => {
        if (res.data.status == "1") {
          this.getCode();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    onswitch(event) {
      var that = this;
      if (!this.switchstatus) {
        this.switchstatus = true;
        var date = new Date();
        this.validcodeurl = this.validcodeurl + "?" + date.getTime();

        setTimeout(function () {
          that.switchstatus = false;
        }, 400);
      }
    },
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timeshow = true;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timeshow = false;
            this.timer = null;
          }
        }, 1000);
      }
    },
  },
};
</script>
<style src="../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../assets/css/common/form.less" scoped lang="less"></style>
<style src="../../assets/css/common/details.less" scoped lang="less"></style>
<style src="../../assets/css/common/additional.less" scoped lang="less"></style>
<style lang="less" scoped>
.el-main {
  height: calc(100vh - 60px);
}
/*.tab_nav {
		padding: 16px 0;
		height: auto;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		border-bottom: 1px solid #f2f5f8;
		.nav {
			margin-bottom: 0;
			display: flex;
			align-items: center;
			height: auto;
		}
	}*/

.stepdiv {
  width: 100%;
  .steps {
    width: 400px;
    margin: 40px auto;
  }
}

.m_nav {
  width: 100%;
  margin: 25px 0;
}
.mobile {
  font-size: 12px;
  font-weight: bold;
  position: relative;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #545566;
  font-weight: bold;
}

.formclass {
  text-align: center;
  width: 40%;
  margin-left: 30%;
}

.mobilecert {
  position: absolute;
  right: -120px;
  top: 4px;
  height: 30px;
  display: flex;
  align-items: center;
}

.imgcert {
  right: -83px;
}
.nosmsbtn {
  position: absolute;
  right: -120px;
  top: 4px;
  border: 1px solid #cdcdcd;
  height: 30px;
  padding: 0 13px;
  border-radius: 6px;
  min-width: 84px;
  color: #636363;
  font-size: 14px;
  background-color: #f2f2f5;
  cursor: pointer;
  float: right;
}
.el-icon-circle-check {
  position: absolute;
  right: -30px;
  top: 50%;
  margin-top: -10px;
  font-size: 20px;
  color: #3bc798;
}
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
</style>
